// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"18e4931a","223":"096147d0","239":"cea101f0","319":"bf18a1c7","453":"c50aa962","455":"e5c19bf4","533":"ccdde25c","556":"5724c9e7","750":"4c0056d9","837":"74649b27","977":"16898b68"}[chunkId] + ".chunk.js";
};